/******************************************************************************************
 *	Offers Service
 ********************************************************************************************/
(function() {


  angular.module('rcCommerce.offers', ['binky.core.offers']).service(
    'Offers',
    /* @ngInject */
    function(
      _,
      $log,
      $q,
      DefaultResponseTransformer,
      DemoMode,
      feature,
      jilOrganizationsOffers,
      jilOrganizationsContractOffers,
      MiniJil,
      Offer,
      QUALIFIER_TARGET
    ) {
      this.get = function(customer) {
        if (DemoMode.isEnabled()) {
          const offers = MiniJil.getOffers(customer.id);
          if (offers) {
            return $q.resolve(getOffersFromResponse(offers, {}));
          } else {
            return $q.reject({
              data: {},
              status: 404
            });
          }
        } else if(feature.isEnabled('temp_use_pores')){
          return jilOrganizationsOffers.offers
          .query({
            intent: 'aac_offer_discovery_purchase',
            orgId: customer.id,
            page: 0,
            page_size: 100,
            service_providers: 'MERCHANDISING,PRODUCT_ARRANGEMENT',
            contractId: customer.vipnumber
          })
          .$promise.then(responseData => {
            // eslint-disable-next-line lodash/prop-shorthand
            const rawOffers = _.map(responseData, item => item.offer);
            responseData = getOffersFromResponse(rawOffers);
            return responseData;
          })
          .catch(err => {
            $log.error('Failed to fetch offer data', err);
          });

        } else if(feature.isEnabled("temp_use_pa_v2")){
          return jilOrganizationsContractOffers.offers
            .query({
              contractId: customer.vipnumber,
              orgId: customer.id,
              page: 0,
              page_size: 100,
              service_providers: 'MERCHANDISING,PRODUCT_ARRANGEMENT_V2'
            })
            .$promise.then(responseData => {
              responseData = getOffersFromResponse(responseData);
              return responseData;
            })
            .catch(err => {
              $log.error('Failed to fetch offer data', err);
            });
        }
        else {
          return jilOrganizationsContractOffers.offers
            .query({
              contractId: customer.vipnumber,
              orgId: customer.id,
              page: 0,
              page_size: 100,
              service_providers: 'MERCHANDISING,PRODUCT_ARRANGEMENT'
            })
            .$promise.then(responseData => {
              responseData = getOffersFromResponse(responseData);
              return responseData;
            })
            .catch(err => {
              $log.error('Failed to fetch offer data', err);
            });
        }
      };

      function getOffersFromResponse(responseData) {
        let data = DefaultResponseTransformer.processData(responseData);
        const offersBySegment = {allValidOffers: [], evipOffers: [], teamOffers: []};

        _.forEach(data, function(offer) {
          // filter out offers that don't have copy (product name, etc), since we can't display them
          if (_.has(offer, 'merchandising.copy')) {
            const binkyOffer = new Offer(offer);
            // Filter out offers that have PREVENT_PA_CREATION qualifier
            if (!binkyOffer.hasQualifier(QUALIFIER_TARGET.PREVENT_PA_CREATION)) {
              offersBySegment.allValidOffers.push(binkyOffer);
              // we don't want device offers in our segments at this point. If we ever allow Device PAs this filter
              // can be revisited.
              if (binkyOffer.isEnterpriseOffer() && !binkyOffer.isDeviceOffer()) {
                offersBySegment.evipOffers.push(binkyOffer);
              }
              if (binkyOffer.isTeamOffer() && !binkyOffer.isDeviceOffer()) {
                offersBySegment.teamOffers.push(binkyOffer);
              }
            }
          }
        });

        return offersBySegment;
      }
    }
  );
})();
